<div class="history-table-container" *ngIf="gameHistory">
  @if (
    !loading &&
    totalGameHistory === 0 &&
    gameHistoryFiltered !== null &&
    gameHistoryFiltered !== undefined
  ) {
    <fz-empty-list
      [isLoggedIn]="loggedIn"
      [buttonText]="emptyActionText"
      (buttonEvent)="onButtonClicked()"
      (loginEvent)="onLogin($event)"
    >
    </fz-empty-list>
  }
  <div *ngIf="totalGameHistory ?? 0 > 0">
    @if (!disableFilter) {
      <div class="header-container">
        <div class="tablet-adjustment bottom-spacer">
          @if (gameHistory) {
            <div class="tablet-adjustment__content">
              @if (showFilterButton) {
                <fz-filter-button
                  class="filter-button"
                  (filterChange)="onToggleFilter($event)"
                  *ngIf="showFilterButton"
                ></fz-filter-button>
              }
              <h4 class="content-title mat-body-large">
                Select a row to view game history details
              </h4>
            </div>
          }
        </div>
      </div>
    }
    <div class="row">
      <div class="filter-ctn" [hidden]="showFilter !== true">
        @if (totalGameHistory || 0 > 0) {
          <fz-filter
            [arrayToFilter]="gameHistory"
            (filterChange)="onFilterHistoryChange($event)"
            [model]="filterHistoryModel"
            (modelChange)="refreshModel($event)"
          ></fz-filter>
        }
      </div>
      <div class="table-container" [class.filterOpened]="showFilter === true">
        <fz-shared-table-component
          [displayedColumns]="displayedColumns"
          [loading]="loading"
          [configuration]="configuration"
          [isLoggedIn]="loggedIn"
          [dataSource]="gameHistoryFiltered"
          (detailsButtonPressed)="onView($event)"
          (elementClicked)="elementClicked($event)"
          (pageChanged)="onPageChange($event)"
        ></fz-shared-table-component>
      </div>
    </div>
  </div>
</div>
@if (!gameHistoryFiltered) {
  <div>
    <h4 class="content-title" style="padding-left: 20px">
      Select a row to view game history details
    </h4>
    <fz-loading-component [total]="1"></fz-loading-component>
  </div>
}
